import React, { memo } from "react";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Controller } from "react-hook-form";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Stack, Typography } from "@mui/material";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const CustomDatePicker = ({
  control,
  name,
  label,
  rules = {},
  stackProps = {},
  labelPosition = "",
  textFieldProps = {},
  ...others
}) => {
  return (
    <Stack
      {...stackProps}
      flexDirection={labelPosition === "left" ? "row" : "column"}
      spacing={labelPosition ? 1 : 0}
      className="custom-input-container field-container"
      sx={{ width: '100%', ...stackProps.sx }}
    >
      {labelPosition && (
        <Typography 
          className="label" 
          variant="subtitle2" 
          sx={{ 
            fontSize: '13px', 
            fontWeight: 600, 
            color: '#334155',
            minWidth: labelPosition === "left" ? '100px' : 'auto'
          }}
        >
          {label || ""}
        </Typography>
      )}

      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <Controller
          control={control}
          name={name}
          rules={rules}
          render={({ field, fieldState: { error } }) => (
            <DatePicker
              {...field}
              label={labelPosition ? "" : label || ""}
              value={
                field.value && dayjs(field.value)?.isValid()
                  ? dayjs(field.value)
                  : null
              }
              onChange={(date) => field.onChange(date)}
              slotProps={{
                textField: {
                  error: !!error,
                  helperText: error?.message || "",
                  size: "small",
                  fullWidth: true,
                  sx: {
                    '& .MuiInputBase-root': {
                      fontSize: '12px',
                      borderRadius: '8px',
                      backgroundColor: '#f8fafc'
                    },
                    '& .MuiInputLabel-root': {
                      fontSize: '13px',
                    },
                    ...textFieldProps.sx
                  },
                  ...textFieldProps,
                },
              }}
              {...others}
            />
          )}
        />
      </LocalizationProvider>
    </Stack>
  );
};

export default memo(CustomDatePicker);
